import Vue from 'vue'
import Element from 'element-ui'
import '@/plugins/element/element-variables.scss'

Vue.use(Element)